import type { ImagesService } from '@/engine/app/modules/images/Images.service.ts';
import type { IImageScrollStrategy, SliceType } from '@/engine/app/modules/images/interfaces.ts';

export class ImageSliderScrollStrategy implements IImageScrollStrategy {
  private _imagesService: ImagesService

  public constructor(imagesService: ImagesService,) {
    this._imagesService = imagesService;
  }

  public handleScroll(delta: number, sliceType: SliceType): void {
    const imagesInfo = this._imagesService.getImageSliceOrientationInfo(sliceType);
    const slicesCount = imagesInfo.slicesCount;
    const sliceIndex = imagesInfo.currentSlice;

    if (typeof slicesCount === 'undefined' || typeof sliceIndex === 'undefined') {
      return;
    }

    const sliceToRequest = sliceIndex + Math.round(delta);

    if (sliceToRequest >= 0 && sliceToRequest <= slicesCount) {
      this._imagesService.requestSlice(sliceType, sliceToRequest);
    }
  }
}
